import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';

import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { SvinnReportService } from '../../services/svinn-report.service';
import { MatTableDataSource } from '@angular/material/table';
import { ProductService } from '../product/product.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSelectChange } from '@angular/material/select';
import { Observable, Subject, combineLatest, map, startWith, } from 'rxjs';
import { ConfigService } from 'src/app/shared/config';
import { FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from 'src/app/shared/excel';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { MatDialog } from '@angular/material/dialog';
import { SvinnReportPopupComponent } from './svinn-report-popup/svinn-report-popup.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';





@Component({
  selector: 'app-svinn-report',
  templateUrl: './svinn-report.component.html',
  styleUrls: ['./svinn-report.component.css']
})
export class SvinnReportComponent implements OnInit, OnDestroy {
  columnTotals: { [key: string]: number } = {};
  inputDateFrom
  inputDateTo;
  timeSelected;
  @ViewChild(MatSort) sort: MatSort;
  loading = false;


  uniqueDates: string[];
  uniqueNames: string[] = [];
  uniqueSystems: string[] = [];

  systemControl = new FormControl();
  categoryControl = new FormControl();
  selectedSystems: Array<any> = []
  selectedCategories: Array<any> = []
  systems$;
  systemsFilter$ = new Subject()
  filteredSystems$;
  systemsArray
  categories$;
  categories;
  categoriesSubscription;
  categoriesFilter$ = new Subject()
  categoriesSystems$;
  exportData = [];
  selectedValuesForSystem = [];
  selectedValuesForCategories = [];
  svinnData$ = new Observable();

  transactions = [];
  svinn = [];

  displayedColumns: string[] = ['name', 'number'];

  openPopupEmitterEvent = new EventEmitter<ActionButtonEvent>()

  customDateRange = { start: null, end: null };
  excludeWeekends = false;
  aggregateCategoriesOnly = false;
  actionButtons = [{ icon: 'search', tooltip: 'Details', eventEmitter: this.openPopupEmitterEvent }]
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'systemName',
      name: 'System'
    },
    {
      columnId: 'category',
      name: 'Category'
    },
    {
      columnId: 'sales',
      name: 'Sales',
      isNumber: true
    },
    {
      columnId: 'svinn',
      name: 'Svinn',
      isNumber: true
    },
    {
      columnId: 'svinnMax',
      name: 'Svinn Max',
      isNumber: true
    },
    {
      columnId: 'svinnPercentage',
      name: 'Svinn %',
      isNumber: true
    },
    {
      hidden: true,
      columnId: 'systemId',
      name: 'System ID',
    }

  ]



  data = []
  dataSource = new MatTableDataSource(this.data);
  constructor(private excelService: ExcelService, private config: ConfigService, private svinnService: SvinnReportService, private productService: ProductService, private dialog: MatDialog) {

  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }
  ngOnInit(): void {

    this.openPopupEmitterEvent.subscribe((event: ActionButtonEvent) => {
      console.log(event);
      this.openDialog(event.eventData.systemId, event.eventData.category);
      // this.openDialog(event.data.system, event.data.category);
    });

    this.categoryControl.setValue('all');
    this.systemControl.setValue('all');
    this.timeSelected = 'LAST-7-DAYS';

    this.systemControl.valueChanges.subscribe(values => {
      if (values.includes("selectAllSystems"))
        this.filteredSystems$.subscribe(sp => {
          values = sp.map(d => d.systemName)
          this.selectedValuesForSystem = values
        })
      else
        this.selectedValuesForSystem = values
    });

    this.categoryControl.valueChanges.subscribe(values => {
      if (values.includes("all"))
        this.timeSelected = 'LAST-7-DAYS';
      else
        this.selectedValuesForCategories = values
    });



    this.systems$ = this.svinnService.getMappingByCompanyId(this.config.getCompanyId())

    this.systems$.subscribe(systems => {
      this.systemsArray = systems;
    })

    this.categories$ = this.svinnService.getCategories(this.config.getCompanyId()).pipe(map((categories) => categories.sort((a, b) => a.name.localeCompare(b.name))));

    this.categoriesSubscription = this.categories$.subscribe(cats => {
      this.categories = cats.sort((a, b) => a.name.localeCompare(b.name));
    });

    this.filteredSystems$ = combineLatest(
      this.systems$, this.systemsFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        return (data as Array<{}>).filter(option => option['systemName'] ? option['systemName'].toLowerCase().includes(filter) : "Test")
      }))




  }

  ngOnDestroy(): void {
    this.categoriesSubscription.unsubscribe();
  }

  setSystem(obj) {
    this.selectedSystems.push(obj)
  }
  setCategory(obj) {
    this.selectedCategories.push(obj)
  }

  setTimePeriodeEvent(event: MatSelectChange) {
    this.setTimePeriode(event.value);
  }

  setTimePeriode(value) {
    try {

      const now = moment();

      let from;
      let to;
      switch (value) {
        case 'TODAY':
          from = moment(now).startOf('day').unix();
          to = now.endOf('day').unix();
          break;
        case 'YESTERDAY':
          from = moment(now).subtract(1, 'days').startOf('day').unix();
          to = moment(now).subtract(1, 'days').endOf('day').unix();
          break;
        case '24H':
          from = moment(now).subtract(1, 'days').unix();
          to = moment(now).unix();
          break;
        case 'LAST-7-DAYS':
          from = moment(now).subtract(7, 'days').startOf('day').unix();
          to = moment(now).endOf('day').unix();
          break;
        case 'THIS_MONTH':
          from = moment(now).startOf('month').unix();
          to = moment(now).endOf('day').unix();
          break;
        case 'LAST_MONTH':
          from = moment(now).subtract(1, 'month').startOf('month').unix();
          to = moment(now).subtract(1, 'month').endOf('month').unix();
          break;
        case 'CUSTOM':
          return;
          break;
        default:
          throw new Error("Unhandled select time case!")
      }

      this.inputDateFrom = from;
      this.inputDateTo = to;


    } catch (err) {
      console.log(err.message)
    }

  }

  openDialog(systemId, category) {

    const systemName = systemId ? this.systemsArray.find(s => s.systemId === systemId)?.systemName : "All systems"

    const systemTransactions = this.transactions.filter(t => t['systemId'] === systemId && t['categories'] && t['categories'].includes(category));
    const systemSvinn = this.svinn.filter(s => s['systemId'] === systemId && s['name'] === category);

    this.dialog.open(SvinnReportPopupComponent, {
      width: '400px',
      maxHeight: '80vh',            // optional 
      data: {
        transactions: systemTransactions,
        svinn: systemSvinn,
        from: this.inputDateFrom,
        to: this.inputDateTo,
        systemName: systemName,
        category: category,
        excludeWeekends: this.excludeWeekends
      }
    });
  }


  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {
    if (picker === 'start') {
      this.inputDateFrom = moment(event.value).startOf('day').unix();
    } else {
      this.inputDateTo = moment(event.value).endOf('day').unix()
    }
  }

  isLargeQuery() {
    let isBig = false;

    if (this.inputDateFrom && this.inputDateTo) {
      const daysDiff = moment.unix(this.inputDateTo).diff(moment.unix(this.inputDateFrom), 'days');
      isBig = daysDiff > 7;
    }

    if (this.categoryControl.value == 'all' && this.systemControl.value == 'all') {
      isBig = true;
    }

    return isBig;
  }

  showExtraDateOptions() {
    return this.categoryControl.value !== 'all' || this.systemControl.value !== 'all';
  }

  onSubmit() {
    this.loading = true;
    let category = null;
    let systemId = null;

    if (this.categoryControl.value && this.categoryControl.value != 'all') {
      if (!this.categories.includes(this.categoryControl.value)) {
        category = this.categoryControl.value;
      }
    }

    if (this.systemControl.value && this.systemControl.value != 'all') {
      systemId = this.systemControl.value;
    }

    if (!this.inputDateFrom || !this.inputDateTo) {
      this.inputDateFrom = moment().subtract(7, 'days').startOf('day').unix();
      this.inputDateTo = moment().endOf('day').unix();
    }

    const svinn$ = this.svinnService.getSvinnByCompanyId(this.config.getCompanyId(), this.inputDateFrom, this.inputDateTo, category, systemId).pipe(map(snapshot => {
      if (snapshot) {
        const res = snapshot.docs.map(doc => doc.data());
        this.svinn = res;
        return res
      } else {
        return []
      }
    }));

    const transactions$ = this.svinnService.getTransactionsByCompanyId(this.config.getCompanyId(), this.inputDateFrom, this.inputDateTo, category, systemId).pipe(map(snapshot => {
      if (snapshot) {
        const res = snapshot.docs.map(doc => doc.data());
        this.transactions = res;
        return res
      } else {
        return []
      }
    }));

    const systems$ = this.svinnService.getSystemsByCompanyId(this.config.getCompanyId()).pipe(map(snapshot => {
      return snapshot.docs.map(doc => doc.data());
    }));

    this.svinnData$ = combineLatest([svinn$, transactions$, systems$]).pipe(map(([svinn, transactions, systems]) => {

      if (this.aggregateCategoriesOnly) {
        // Aggregate across all systems: produce per-category totals for sales and svinn
        const salesPerCategory = transactions.reduce((acc, transaction) => {
          if (this.excludeWeekends) {
            const entryDate = moment.unix(transaction['unix']).tz('Europe/Oslo');
            if (entryDate.isoWeekday() === 6 || entryDate.isoWeekday() === 7) {
              return acc;
            }
          }
          const category = transaction['categories'] && transaction['categories'][0];
          if (!category) return acc;
          acc[category] = (acc[category] || 0) + transaction['quantity'];
          return acc;
        }, {});

        const svinnPerCategory = svinn.reduce((acc, svinnEntry) => {
          if (this.excludeWeekends) {
            const entryDate = moment.unix(svinnEntry['unix']).tz('Europe/Oslo');
            if (entryDate.isoWeekday() === 6 || entryDate.isoWeekday() === 7) {
              return acc;
            }
          }
          const category = svinnEntry['name'];
          acc[category] = (acc[category] || 0) + svinnEntry['number'];
          return acc;
        }, {});

        const categories = Array.from(new Set([...Object.keys(salesPerCategory), ...Object.keys(svinnPerCategory)]));

        const tableData = categories.map(category => {
          const salesCount = salesPerCategory[category] || 0;
          const svinnCount = svinnPerCategory[category] || 0;
          let svinnPercentage = 0;
          if (salesCount === 0 && svinnCount > 0) svinnPercentage = 100;
          else if (svinnCount === 0) svinnPercentage = 0;
          else svinnPercentage = (svinnCount / (salesCount + svinnCount)) * 100;

          return {
            systemName: 'All systems',
            category,
            sales: salesCount || '0',
            svinn: svinnCount || '0',
            svinnMax: '0',
            svinnPercentage: svinnPercentage ? svinnPercentage.toFixed(0) : '0',
            systemId: null
          };
        });

        this.loading = false;
        return tableData;
      }

      const systemIds = [...transactions.map(t => t['systemId']), ...svinn.map(s => s['systemId'])].reduce((acc, id) => {
        if (!acc.includes(id)) {
          acc.push(id);
        }
        return acc;
      }, [] as string[]);

      const salesPerSystem = transactions.reduce((acc, transaction) => {

        const systemId = transaction['systemId'];
        const category = transaction['categories'][0];

        if (this.excludeWeekends) {
          const entryDate = moment.unix(transaction['unix']).tz('Europe/Oslo');
          if (entryDate.isoWeekday() === 6 || entryDate.isoWeekday() === 7) {
            return acc; // Skip this entry if it's Saturday (6) or Sunday (7)
          }
        }

        if (!category) {
          return acc;
        }

        if (!acc[systemId]) {
          acc[systemId] = {};
        }

        acc[systemId][category] = (acc[systemId][category] || 0) + transaction['quantity'];
        return acc;
      }, {});

      const svinnPerSystem = svinn.reduce((acc, svinnEntry) => {

        const systemId = svinnEntry['systemId'];
        const category = svinnEntry['name'];

        if (this.excludeWeekends) {
          const entryDate = moment.unix(svinnEntry['unix']).tz('Europe/Oslo');
          if (entryDate.isoWeekday() === 6 || entryDate.isoWeekday() === 7) {
            return acc; // Skip this entry if it's Saturday (6) or Sunday (7)
          }
        }

        if (!acc[systemId]) {
          acc[systemId] = {};
        }

        if (!acc[systemId][category]) {
          acc[systemId][category] = [];
        }

        acc[systemId][category].push(svinnEntry['number']);
        return acc;
      }, {});

      // Combine sales and svinn data
      const tableData = systemIds.reduce((acc, systemId) => {

        const systemName = systems.find(s => s['systemId'] === systemId)?.['name'] || systemId;

        const systemCategories = new Set([
          ...Object.keys(salesPerSystem[systemId] || {}),
          ...Object.keys(svinnPerSystem[systemId] || {})
        ]);

        systemCategories.forEach(category => {

          const salesCount = salesPerSystem[systemId]?.[category] || 0;
          let svinnCount = 0;
          let svinnMax = 0;

          if (svinnPerSystem[systemId]?.[category]) {
            svinnPerSystem[systemId][category].forEach(num => {
              svinnCount += num;
            });
          }

          if (svinnCount > 0 && svinnPerSystem[systemId]?.[category]) {
            svinnMax = Math.max(...svinnPerSystem[systemId][category]);
          }

          let svinnPercentage = 0;

          if (salesCount === 0 && svinnCount > 0) {
            svinnPercentage = 100;
          } else if (svinnCount === 0) {
            svinnPercentage = 0;
          } else {
            svinnPercentage = (svinnCount / (salesCount + svinnCount)) * 100;
          }

          acc.push({
            systemName,
            category,
            sales: salesCount ? salesCount : "0",
            svinn: svinnCount ? svinnCount : "0",
            svinnMax: svinnMax ? svinnMax.toFixed(0) : "0",
            svinnPercentage: svinnPercentage ? svinnPercentage.toFixed(0) : "0",
            systemId: systemId
          });
        });

        this.loading = false;

        return acc;

      }, []);

      return tableData
    }));
  }

  calculateMedian(numbers: number[]): number {
    const sorted = [...numbers].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
  }
}
